import React from "react";
import useStyles from "./Styles";
import { Box, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import ChartTitle from "./ChartTitle";
import userActions from "./actions";
import appActions from "../app/actions";
import AreaChart from "./AreaChart/AreaChart";
import { useLocation } from "react-router-dom";

// Chart Imports
import ColoradoRiverAccessMap from "./ColoradoRiverAccess/ColoradoRiverAccessMap";
import GaugePie from "./GaugePieChart/GaugePie";
import IrrigationView from "./CentralAZWaterUse/IrrigationView";
import PolygonMapView from "./PolygonMap/PolygonMapView";
// import useIsDevUrl from "hooks/useIsDevUrl";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const ChartView = () => {
  const classes = useStyles();
  const location = useLocation();
  const {
    setChart,
    loadIrrigationDistricts,
    loadAgricultureDistrictWater,
    loadWaterDeliveries,
    // loadCityMetrics,
    loadCities,
    loadEntityEntitlements,
    loadPriorityEntitlements,
  } = userActions();
  const { chart, scenario_selected } = useSelector(
    (state) => state.technical_view
  );
  const { loggedIn } = useSelector((state) => state.auth);
  const { setChartDrawerStateToClose } = appActions();
  // const isDevUrl = useIsDevUrl();
  const {isMobile} = useGetViewPortDimensions();

  // React.useEffect(() => {

  //   return () => {
  //     setChart("colorado_river_access");
  //   };
  // }, []);

  const componentMount = async () => {
    await loadIrrigationDistricts();
    await loadAgricultureDistrictWater();
    await loadWaterDeliveries();
    // await loadCityMetrics(1); //as default, we will show the information for the first item in the dropdown menu
    await loadEntityEntitlements(1);
    await loadCities();
    await loadPriorityEntitlements(scenario_selected.value);
    const chart = location.pathname.split("/")[2];
    switch (chart) {
      case "map":
        setChart("colorado_river_access");
        break;
      case "honeycomb":
        setChart("access_per_capita");
        break;
      case "doughnut":
        setChart("central_az_water_use");
        break;
      case "area":
        setChart("colorado_river_water_access");
        break;
      case "gauge":
        setChart("water_use_versus_access");
        break;
      default:
    }
  }

  React.useEffect(componentMount, []);
  return (
    <Box
      className={classes.chartView}
      onClick={() => {
        setChartDrawerStateToClose();
      }}
    >
      <Grid container>
        <Grid item xs={12} align="center">
      {chart === "colorado_river_access" && loggedIn ? (
        <ChartTitle
          floating={true}
          style={ !isMobile ? {width: "100%"} : null}
          title={"Colorado River Water Access"}
          subtitle={""}
          background="#EDEDED"
        />
      ) : chart === "central_az_water_use" && loggedIn ? (
        <ChartTitle
          title={"Central Arizona Water Deliveries and Uses - 2020"}
          subtitle={""}
        />
      ) : chart === "colorado_river_water_access" && loggedIn ? (
        <ChartTitle title={"Colorado River Access by Water Priority Level"} subtitle={""} />
      ) : chart === "water_use_versus_access" && loggedIn ? (
        <ChartTitle
          title={"  Central Arizona Colorado River Water Use vs. Access"}
          subtitle={""}
        />
      ) : (
        ""
      )}
        </Grid>
      </Grid>
      {
        {
          access_per_capita: <PolygonMapView />,
          colorado_river_access: <ColoradoRiverAccessMap />,
          central_az_water_use: <IrrigationView />,
          // colorado_river_water_access: <CentralArizonaSankey />,
          water_use_versus_access: <GaugePie />,
          colorado_river_water_access: <AreaChart />, // {/* muraishi here to add  */
        }[chart]
      }
    </Box>
  );
};

export default ChartView;
